import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Native Services">
                            <h2>Business Benefits Of Investing In Cloud Native Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol’s cloud-native capabilities have enabled businesses to leverage public, private, and
                            hybrid clouds to achieve their business goals 2x faster. Here is what our cloud native
                            development services and solutions guarantee for businesses:</p>
                        <ul>
                            <li>Cost-effective storage options</li>
                            <li>Quickest access to resources without geographical barriers</li>
                            <li> Business agility and competitive advantage</li>
                            <li>System security and protection</li>
                            <li> Easiest system implementations</li>
                            <li> Convenient process deployment</li>
                            <li> And endless possibilities for scaling your hardware and software results.</li>
                            <li> Have other use cases of cloud native for your organization?</li>
                        </ul>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;